module.exports = __webpack_public_path__ + "static/lead-yourself-first-3004fcab9d5a9240859cd031684b450d.jpg";